// This file was auto-generated by Fern from our API Definition.
export var SimpleWorkflowDataOutput;
(function (SimpleWorkflowDataOutput) {
    SimpleWorkflowDataOutput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(SimpleWorkflowDataOutput || (SimpleWorkflowDataOutput = {}));
